import Box from "@mui/material/Box";
import { unstable_useEnhancedEffect as useEnhancedEffect } from "@mui/utils";
import {
  GridColDef,
  GridRenderCellParams,
  useGridApiContext,
} from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "jalali-moment";
import { useEffect, useRef } from "react";

function DatePickerEditInputCell(props: GridRenderCellParams<any, any>) {
  const { id, value, field, hasFocus } = props;
  const apiRef = useGridApiContext();
  const ref = useRef<any>(null);

  const handleChange = (date: Date | null) => {
    if (date) {
      apiRef.current.setEditCellValue({ id, field, value: date });
    } else {
      console.log("Invalid date received.");
      apiRef.current.setEditCellValue({ id, field, value: "" });
    }
  };

  useEnhancedEffect(() => {
    if (hasFocus && ref.current) {
      const input = ref.current.querySelector("input");
      input?.focus();
    }
  }, [hasFocus, value]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", pr: 2, width: "100%" }}>
      <DatePicker
        value={value}
        sx={{ width: "100%" }}
        onChange={handleChange}
        inputRef={ref} // استفاده از inputRef به جای ref مستقیم
      />
    </Box>
  );
}

export const renderDateEditInputCell: GridColDef["renderCell"] = (params) => {
  return <DatePickerEditInputCell {...params} />;
};

export function renderDate(params: GridRenderCellParams<any, number>) {
  return moment(params.value).locale("fa").format("YYYY/MM/DD"); // تاریخ شمسی به فرمت دلخواه
}
